'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"breadcrumb__text":"style-module_breadcrumb__text__k9aHn"};

exports.default = style;
//# sourceMappingURL=style.module.scss.js.map
